import { BaseModel, ToFrontHook, ToBackHook, ModelInstance, enumField, listField } from './util';
import { TournamentDivision } from './tournament-division';

export enum TournamentRoundTypes {
  group = 1,
  playoff,
  swiss,
}

export class TournamentRoundSettings extends BaseModel {
  toursCount: number;
}

@ModelInstance({
  mappingFields: {
    id: 'id',
    name: 'name',
    type: 'type',
    divisions: 'divisions',
  },
  relation: {
    type: enumField(TournamentRoundTypes),
    divisions: listField(TournamentDivision),
  }
})
export class TournamentRound extends BaseModel {
  id: number;
  name: string;
  type: TournamentRoundTypes;
  divisions: TournamentDivision[];

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
